// @tenorlab/nuxt-dashboard-pro
// file: app/theme/use-data-theme.ts
export const LIGHT_THEME_NAME = 'light'
export const DARK_THEME_NAME = 'slate'

const getFromLocalStorage = () => {
  const strTheme = (localStorage.getItem('theme') || '').trim()
  if (strTheme.length > 0) {
    return strTheme
  }
  return ''
}

const getDefaultTheme = () => {
  // Check if we are in a browser environment
  if (typeof window === 'undefined') {
    return LIGHT_THEME_NAME
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? DARK_THEME_NAME : LIGHT_THEME_NAME
}

const setThemeIdOnDocumentElement = (themeId: string) => {
  const handler = () => {
    const documentElement = document.documentElement
    //documentElement.dataset.viewtransition = 'vertical'
    documentElement.dataset.theme = themeId
    // const classes = documentElement.className.split(' ').filter((x) => !x.endsWith('-theme'))
    // documentElement.className = [themeId, ...new Set(classes)].join(' ')
  }

  const doc = document as any
  if (doc?.startViewTransition) {
    setTimeout(() => doc.startViewTransition(handler), 50)
  } else {
    handler()
  }
}

export const useDataTheme = () => {
  const dispatchThemeChanged = (value: string) => {
    document.documentElement.dispatchEvent(
      new CustomEvent('themechanged', {
        bubbles: false,
        detail: value,
      }),
    )
  }

  const setDataTheme = (value: string) => {
    const newTheme = value || getDefaultTheme()
    setThemeIdOnDocumentElement(newTheme)

    localStorage.setItem('theme', newTheme)
    dispatchThemeChanged(newTheme)
  }

  const getCurrentDataTheme = () => {
    return document.documentElement.getAttribute('data-theme') || getDefaultTheme()
  }

  const toggleDataTheme = () => {
    const newTheme = getCurrentDataTheme() === DARK_THEME_NAME ? LIGHT_THEME_NAME : DARK_THEME_NAME
    setDataTheme(newTheme)
    return newTheme
  }

  return {
    getCurrentDataTheme,
    toggleDataTheme,
    setDataTheme,
    restoreDataTheme: () => setDataTheme(getFromLocalStorage()),
  }
}
